import styles from './styles.module.scss';
import Input from 'components/Input';
import Button from 'components/Button';
import dossierService from 'api/dossierService';
import { FC, useState } from 'react';
import { Props } from './typings';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

const EditFolder: FC<Props> = ({ folderName, dossierId, toggle, refetch }) => {
  const [name, setName] = useState(folderName);

  const { mutate: updateFolder } = dossierService.useUpdateLabel();

  const handleClickSave = () => {
    updateFolder(
      {
        Id: dossierId,
        Label: name,
      },
      {
        onSuccess: () => {
          refetch();
          toggle(false);
        },
      }
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        Zmień nazwę
        <CloseIcon onClick={() => toggle(false)} className={styles.closeIcon} />
      </div>
      <div className={styles.content}>
        <Input
          placeholder="Nazwa folderu"
          label="Nazwa"
          value={name}
          onChange={(text) => setName(text)}
        />
      </div>
      <div className={styles.footer}>
        <Button
          disabled={!name.length}
          onClick={handleClickSave}
          text="Zapisz"
        />
      </div>
    </div>
  );
};

export default EditFolder;
